<template>
  <div>
    <user-detail-title
      first-bread="标签管理"
      second-bread="产品标签"
      third-bread="产品标签查看"
      first-url="/user/sign"
      second-url="/user/sign"
      title-name="产品标签查看"
    >
    </user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">

        <el-form-item label="名称">
          <p>{{ LookData.name }}</p>
        </el-form-item>
        <el-form-item label="logo">
          <el-image class="item-image" :src="'http://'+LookData.logoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="上级分类">
          <p>{{ LookData.superClassifyName }}</p>
        </el-form-item>
        <el-form-item label="创建时间">
          <p>{{ LookData.createTime }}</p>
        </el-form-item>
        <el-form-item label="更新时间">
          <p>{{ LookData.updateTime }}</p>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "ProductSignLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/productLabel/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>